exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/full-fact-sheet/full-fact-sheet-page-1/full-fact-sheet-business-description/full-fact-sheet-business-description.component.scss
// module id = ../../../../../src/app/securities-level/full-fact-sheet/full-fact-sheet-page-1/full-fact-sheet-business-description/full-fact-sheet-business-description.component.scss
// module chunks = main